module.exports = __webpack_public_path__ + "static/media/imagem-nao-definida.3f1843f3.jpg";